import { render } from "./DashboardSuper.vue?vue&type=template&id=14a07b95"
import script from "./DashboardSuper.vue?vue&type=script&lang=js"
export * from "./DashboardSuper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__